<script setup lang="ts"></script>
<template>
  <div class="loader"></div>
</template>
